import { useCallback } from "react";
import { Paginated, PaginationQuery } from "../../types";
import useApi, { buildUrl } from "../api";
import { Item, KitComponent } from "../item/types";
import { Organization } from "./types";

const useOrganizationApi = () => {
  const baseurl = "/organizations";

  const api = useApi();

  const searchOrganizations = useCallback(
    async (query: PaginationQuery) => {
      const url = buildUrl(baseurl, query);
      const data = await api.get<Paginated<Organization>>({ url });
      return data.items;
    },
    [api],
  );

  const searchNewItems = useCallback(
    async (query: PaginationQuery, organizationID: string) => {
      const url = buildUrl(baseurl + "/" + organizationID + "/new_items", query);
      const data = await api.get<Paginated<Item>>({ url });
      return data.items;
    },
    [api],
  );

  const searchKitComponents = useCallback(
    async (query: PaginationQuery, organizationID: string, kitID: string) => {
      const url = buildUrl(baseurl + "/" + organizationID + "/" + kitID + "/components", query);
      const data = await api.get<KitComponent[]>({ url });
      return data;
    },
    [api],
  );

  return {
    searchOrganizations,
    searchNewItems,
    searchKitComponents,
  };
};

export default useOrganizationApi;
